import { render, staticRenderFns } from "./ExpertYearAssessView.vue?vue&type=template&id=33f58c68&scoped=true"
import script from "./ExpertYearAssessView.vue?vue&type=script&lang=js"
export * from "./ExpertYearAssessView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f58c68",
  null
  
)

export default component.exports